"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RESPONSIVE_DIALOG_DIALOG_FOOTER = exports.RESPONSIVE_DIALOG_DIALOG_CONTENT = exports.RESPONSIVE_DIALOG_DIALOG = void 0;
const RESPONSIVE_DIALOG_DIALOG_CONTENT = exports.RESPONSIVE_DIALOG_DIALOG_CONTENT = 'responsive-dialog-dialog-content';
const RESPONSIVE_DIALOG_DIALOG_FOOTER = exports.RESPONSIVE_DIALOG_DIALOG_FOOTER = 'responsive-dialog-dialog-footer';
const RESPONSIVE_DIALOG_DIALOG = exports.RESPONSIVE_DIALOG_DIALOG = 'responsive-dialog-dialog';
